import { api } from '../../api'
import entities from '../../api/entities'
import { endpointSetter } from '../../api/utils'
import { ApiParams, TrainCompany, TrainCompanyDetail } from '../../types'

interface GetByIdResponse {
  trainCompany: TrainCompanyDetail
}
interface GetAllByFiltersResponse {
  trainCompanies: TrainCompany[]
}

const entity = entities.trainCompany
const endpoint = `/${entity}`
const idEnpointSetter = endpointSetter(endpoint)
const bodyProperty = 'trainCompany'

const getAllByFilters = async ({ filters }: ApiParams) => {
  const response = await api.get<GetAllByFiltersResponse>(endpoint, {
    params: filters,
  })

  return response.data.trainCompanies
}
const getById = async (id: number | string) => {
  const response = await api.get<GetByIdResponse>(idEnpointSetter(id))

  return response.data.trainCompany
}

const post = async (payload: any) => {
  const response = await api.post<any>(endpoint, { [bodyProperty]: payload })

  return response.data.result
}
const put = async (id: number | string, payload: any) => {
  const response = await api.put<any>(idEnpointSetter(id), payload)

  return response.data.result
}

const TrainCompanyApi = { getAllByFilters, getById, post, put }

export default TrainCompanyApi
